import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { storage } from '@uhg-abyss/web/tools/storage';
import { styled } from '@uhg-abyss/web/tools/styled';
import { event } from '@uhg-abyss/web/tools/event';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Link } from '@uhg-abyss/web/ui/Link';
import { IconMaterial } from '@uhg-abyss/web/ui/IconMaterial';

const Container = styled('div', {
  padding: '30px 60px 20px',
});

const StyledMessage = styled('h2', {
  lineHeight: '28px',
  fontSize: '28px',
  marginBottom: 30,
  textAlign: 'center',
});

const StyledButton = styled(Button, {
  width: '100%',
  marginBottom: 15,
});

const CenterAlign = styled('div', {
  textAlign: 'center',
});

const StyledCheckbox = styled(Checkbox, {
  textAlign: 'left',
});

export const ExitLinkModal = ({
  to,
  isOpen,
  onClose,
  canClose,
  modalContent,
  buttonContent,
  storageKey,
  dataTestid,
}) => {
  const [checkboxSelected, setCheckboxSelected] = useState(false);

  const handleClick = () => {
    if (checkboxSelected) {
      storage.local.set(storageKey, true);
    }
    event('EXIT_LINK_NAVIGATE', { linkText: buttonContent });
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      minWidth={600}
      closeOnClickOutside={canClose}
    >
      <Container>
        <StyledMessage data-uhc-brand='font--heading color--blue'>
          {modalContent}
        </StyledMessage>
        <StyledCheckbox
          isChecked={checkboxSelected}
          onChange={() => setCheckboxSelected(!checkboxSelected)}
        >
          Don't show this message again.
        </StyledCheckbox>
        <a
          {...(dataTestid && { 'data-testid': dataTestid })}
          href={to}
          target='_blank'
        >
          <StyledButton
            onClick={handleClick}
            data-testid='paan-ext-link'
            after={<IconMaterial icon='launch' color='white' size={18} />}
          >
            {buttonContent}
          </StyledButton>
        </a>
        <If condition={canClose}>
          <CenterAlign>
            <Link onClick={onClose}>Close</Link>
          </CenterAlign>
        </If>
      </Container>
    </Modal>
  );
};

ExitLinkModal.propTypes = {
  to: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  canClose: PropTypes.bool,
  modalContent: PropTypes.node.isRequired,
  buttonContent: PropTypes.node.isRequired,
  storageKey: PropTypes.string.isRequired,
  dataTestid: PropTypes.string,
};

ExitLinkModal.defaultProps = {
  canClose: true,
  dataTestid: null,
};
